import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Layout, Row, Col, Spin } from 'antd';
import { Link } from 'react-router-dom';
import { listReports } from '../../Store/slices/reports.slice';
import GraphicCard from "../../Components/GraphicCard";

const Reports = () => {
    const dispatch = useDispatch();
    const reportList = useSelector((state) => state.reports.reportList);
    const status = useSelector((state) => state.reports.status);

    useEffect(() => {
        dispatch(listReports());
    }, [dispatch]);

    return (
        <Layout>
            <Layout.Content style={{ margin: '24px 16px 0', overflow: 'initial' }}>
                <Spin spinning={status === 'loading'} tip="Loading reports...">
                    <Row gutter={[16, 16]}>
                        {reportList.map((report) => (
                            <Col key={report.rid} span={8}>
                                <Link to={`/reports/${report.rid}`}>
                                    <GraphicCard
                                        imgUrl={report.img_url}
                                        title={report.title}
                                        description={report.description}
                                    />
                                </Link>
                            </Col>
                        ))}
                    </Row>
                </Spin>
            </Layout.Content>
        </Layout>
    );
};

export default Reports;
